import { PulseEnvironment } from '@pulse/browser-shared';

export function requestURL(url: string | URL, env: PulseEnvironment) {
    try {
        return new URL(typeof url === 'string' ? url : url.href, env.win.location.href).href;
    } catch (ex) {
        if (typeof url === 'string') {
            return url;
        } else if (typeof url === 'object' && url.href) {
            return url.href;
        }
        console.warn(ex);

        return undefined;
    }
}

export function parseContentTypeHeader(value?: string | null) {
    if (!value) {
        return undefined;
    }

    return value
        .toLowerCase()
        .split(';')
        .map((i) => i.trim())[0];
}
